import React from 'react';
import { Typography } from 'antd';
export const WelcomeModalContent = ({ page }) => {
    return (
        <>
            {page === 1 && (
                <>
                    <Typography.Paragraph>
                        RiverMeadow is a Migration and DR Platform that addresses many migration and DR related use
                        cases to public, hybrid and private cloud.
                    </Typography.Paragraph>

                    <Typography.Paragraph>
                        RiverMeadow provides a flexible approach to migration and migration methods including:
                    </Typography.Paragraph>
                    <ul>
                        <li>OS-based Migration - move workloads at an OS-based (Physical, Virtual or Cloud)</li>
                        <li>VM-based Migration - move workloads at a VM-based (Virtual)</li>
                        <li>File Migration - move data volumes to target workloads</li>
                    </ul>
                </>
            )}

            {page === 2 && (
                <>
                    <Typography.Paragraph>
                        RiverMeadow also provides several optimization capabilities that occur on the new target clone
                        as part of migration including:
                    </Typography.Paragraph>
                    <ul>
                        <li>Changes to target Instance or VM size or changes to vCPU (Cores and Sockets) and vRAM</li>
                        <li>
                            Changes to storage performance, storage policies, storage provisioning and partition
                            right-sizing (reduce size on disk before moving to cloud)
                        </li>
                        <li>
                            Changes to networking based on Instance or VM type (ENI, Accelerating Networking), adding
                            NIC's, adding a public IP, preserving or changing IP addressing (Static IP Assignment or
                            DHCP)
                        </li>
                        <li>
                            Changes to OS version - Modernize the target Operating System as part of migration to reduce
                            technical debt. OS modernization occurs on the target clone - source machine is not
                            impacted.
                        </li>
                        <li>
                            Post-migration Automation - scripts can be uploaded to run as part of a migration to
                            transform the target workload as required. A common use case is getting workloads ready for
                            Day 2 operations (replace and add software agents based on the new target platform).
                        </li>
                    </ul>
                </>
            )}
            {page === 3 && (
                <>
                    <Typography.Paragraph>
                        RiverMeadow provides DR capability to protect VM's running in vSphere, AVS, GCVE and VMC to
                        Azure Blob (Object Storage) or to vSphere datastores (vSAN, FC, iSCSI, NFS or Cloud Files CVS)
                    </Typography.Paragraph>

                    <Typography.Paragraph>
                        DR Policies are defined by choosing an RPO value (10 minutes to 24 hours) which determines how
                        often replication will occur. DR Policies also include the number of restore points to maintain
                        (when using Azure Blob) as well as in-scope VM's.
                    </Typography.Paragraph>

                    <Typography.Paragraph>Recovery abilities include</Typography.Paragraph>
                    <ul>
                        <li>Overwrite existing Source VM(s) based on restore point</li>
                        <li>
                            Re-direct recovery back to the Source vSphere environment but choose an alternative VM Name,
                            Cluster, Datastore, VM Network based on restore point
                        </li>
                        <li>Recover VM's to a new vSphere environment in the event of site-wide disaster</li>
                        <li>Power on replica VM's in a Target vSphere environment at time of DR</li>
                    </ul>
                </>
            )}
            {page === 4 && (
                <>
                    <Typography.Paragraph>Let's take a quick tour around the RiverMeadow platform</Typography.Paragraph>

                    <Typography.Paragraph>
                        In the Project Menu, customers can perform the following tasks:
                    </Typography.Paragraph>
                    <ul>
                        <li>
                            Add a Project - A Project is used to logically separate all RiverMeadow capabilities. Users
                            and Entitlements (licenses) are organized into Projects along with any Migration or DR
                            related activities. A new Project is not required. If a new one is not created, all
                            Migration or DR related activities will run out of the Default Project.
                        </li>
                        <li>
                            Assign Users to a Project based on role. Organization Admins can add or remove users using
                            the users email address. A Welcome email is automatically sent to the new User where they
                            will be asked to create a password for authentication. User roles include: Organization
                            Admin, User and Viewer.
                        </li>
                        <li>
                            Assign Migration and/or DR Entitlements. Customer can move unused entitlements between
                            Projects as required. This is helpful for MSP/CSP/SI partners who have many customer
                            projects as entitlement allocation may change throughout the course of a customer project.
                        </li>
                    </ul>
                </>
            )}
            {page === 5 && (
                <>
                    <Typography.Paragraph>
                        In the Manage Menu, Migration customers can perform the following tasks:
                    </Typography.Paragraph>
                    <ul>
                        <li>
                            Migration Appliances - One or more Migration Appliances are required to start performing
                            migrations. The Migration Appliance determines the Target Cloud location. Use this menu item
                            to add, edit, upgrade, delete or troubleshoot Migration Appliances.
                        </li>
                        <li>
                            Source Inventory - Upload or add Sources machines required for migration. For OS-based
                            migrations, Sources can be added using the supplied CSV template or they can be added using
                            a web form in the UI. For VM-based migrations, sources are added by clicking on the Refresh
                            vSphere Sources button and using the supplied filters as required.
                        </li>
                        <li>
                            Move Groups - Move Groups can be created based on Application Stack or project-based
                            construct like waves or sprints. Source machines can then be sorted into Move Groups as
                            required. This can be done via CSV for bulk operations. Move Groups can also contain assign
                            resource and target migration date as additional metadata that can be used in Reporting.
                        </li>
                        <li>
                            Migration Extensions - Are the Post-migration scripts that can be uploaded to run as part of
                            Step 3 in the migration process. Scripts are executed after the target has been prepared for
                            the Target cloud (injecting cloud native drivers and software).
                        </li>
                        <li>
                            Migration Profiles - Are where existing completed Migration Profiles are stored. Migration
                            Profiles can be cloned and rerun if required without the need to input data into the
                            Migration Profile again.
                        </li>
                        <li>
                            Migration Settings - Are Project wide migration settings. These include: Cloud Tags (tags
                            that need to be applied to every single migration - this reduces data input and reduces
                            human error), Advanced Settings like MTU sizing that would be applicable for each migration
                            as well as Migration Instructions (key / value pair). Migration Instructions are created and
                            provided by RiverMeadow to help customers in providing custom code to handle a certain use
                            case.
                        </li>
                    </ul>
                </>
            )}
            {page === 6 && (
                <>
                    <Typography.Paragraph>
                        In the Migrate Menu, Migration customers can perform the following tasks:
                    </Typography.Paragraph>
                    <ul>
                        <li>
                            Setup Migration - An end to end migration setup wizard that will guide you through setting
                            up both full and differential migrations based on defined schedules. Customers who are new
                            to RiverMeadow may want to conduct migrations using this wizard.
                        </li>
                        <li>
                            Start Migration - Is the same as Source Inventory where customers can run Pre-flight checks
                            against many Sources ahead of running migrations as well as start full migrations, File
                            Migrations or VDI migrations.
                        </li>
                        <li>
                            View Migrations - Used to track ongoing and completed migrations. By clicking the “i”
                            button, customers can view detailed migration telemetry as well as get additional insights
                            into migration settings chosen as well as post-migration validation (information about both
                            Source and Target machines). Workload Delta Migrations can also be conducted to completed
                            Workload Migrations.
                        </li>
                        <li>
                            Migration Tracker - Is a customizable digital runbook customers can modify and leverage to
                            track ongoing migrations and associated migration related activities. This data is stateful
                            and allows for several users to update information at the same time. Data can be exported
                            into other tools or spreadsheets as required.
                        </li>
                    </ul>
                </>
            )}
            {page === 7 && (
                <>
                    <Typography.Paragraph>
                        In the Recovery Menu, DR customers can perform the following tasks:
                    </Typography.Paragraph>
                    <ul>
                        <li>
                            Setup - Setup a new Recovery Appliance - One or more Recovery Appliances are required to
                            start performing replications for DR. The Recovery Appliance determines the Target Cloud
                            location (Azure Blob or vSphere). Use this menu item to add, upgrade or delete Recovery
                            Appliances. In the event of a site failure, the RMS Protection Appliance token code can be
                            retrieved to apply to a new appliance in order to recover VM's from Azure Blob or vSphere
                            datastore to a new vSphere environment.
                        </li>
                        <li>
                            DR Policies - Add DR Policy (Provide the Recovery Appliance to be leveraged, provide a
                            Policy Name, choose the desired RPO setting, choose the number of recovery points to retain
                            and select from available VM's to apply the policy to), enable or disable DR Policies, edit
                            an existing DR Policy, check status of replications per DR Policy, Perform Recoveries
                            (overwrite the Source or redirect the recovery to a new VM based on placement criteria) or
                            to or delete DR Policies.
                        </li>
                    </ul>
                </>
            )}
            {page === 8 && (
                <>
                    <Typography.Paragraph>
                        In the Reporting Menu, Migration and/or DR customers can view and download the following
                        Reports:
                    </Typography.Paragraph>
                    <ul>
                        <li>
                            Project Plan - a Gantt Chart based on Start and End date for a Project with milestones that
                            are based on Move Group - Target Migration Dates
                        </li>
                        <li>
                            Workload Migration Status - view the number of full migrations completed, success rates and
                            details about the migrations
                        </li>
                        <li>
                            Workload Delta Migration Status - view the number of differential migrations completed,
                            success rates and details about the migrations
                        </li>
                        <li>
                            Migrations by User - view the migrations assigned to each user (based on Move Group -
                            Assigned Resource)
                        </li>
                        <li>
                            Entitlement Status - view the number of Entitlements currently assigned to a Project vs.
                            consumed
                        </li>
                        <li>
                            DR Policies - view the number of DR Policies, RPO for each policy, number of recovery points
                            retention, policy status and VMs protected by policy
                        </li>
                        <li>Any new reports that will be in this release as it relates to DR</li>
                    </ul>
                </>
            )}
            {page === 9 && (
                <Typography.Paragraph>
                    Detailed documentation including requirements and how to can be found at
                    https://docs.rivermeadow.com (ensure to create an account if you don't already have one).
                </Typography.Paragraph>
            )}
        </>
    );
};
